module.exports = "/img/helpdesk-in-livechat/start-trial-graphic.png?ed075afb5eb54261b2f2291e76740d24";